[
  {
    "id": "s14-head-on-power",
    "rule": 14,
    "cite": [
      "a",
      "b"
    ],
    "scope": "both",
    "title": {
      "en": "Head-on, two power-driven vessels",
      "de": "Kopf auf Kopf, zwei Maschinenfahrzeuge"
    },
    "own": {
      "headingDeg": 0,
      "state": "r23-power-ge50"
    },
    "other": {
      "headingDeg": 180,
      "bearingDeg": 0,
      "distanceNm": 1.5,
      "state": "r23-power-ge50"
    },
    "giveWay": "both",
    "action": {
      "en": "Both alter course to starboard so that each passes on the port side of the other.",
      "de": "Beide gehen nach Steuerbord, jeder lässt den anderen an Backbord vorbei."
    },
    "explanation": {
      "en": "Both masthead lights in line and both sidelights: that is the picture the rule itself describes. There is no stand-on vessel here, both act.",
      "de": "Beide Topplichter in einer Linie und beide Seitenlichter: das ist das Bild, das die Regel selbst beschreibt. Hier gibt es keinen Kurshalter, beide handeln."
    },
    "tags": [
      "power",
      "head-on"
    ],
    "expectSeen": [
      "masthead",
      "sidelight-port",
      "sidelight-stbd"
    ]
  },
  {
    "id": "s14-doubt",
    "rule": 14,
    "cite": [
      "b",
      "c"
    ],
    "scope": "both",
    "title": {
      "en": "Doubt whether it is head-on",
      "de": "Zweifel, ob Kopf auf Kopf"
    },
    "own": {
      "headingDeg": 0,
      "state": "r23-power-ge50"
    },
    "other": {
      "headingDeg": 175,
      "bearingDeg": 3,
      "distanceNm": 2,
      "state": "r23-power-ge50"
    },
    "giveWay": "both",
    "action": {
      "en": "When in doubt, assume a head-on situation exists and alter course to starboard.",
      "de": "Im Zweifel so handeln, als wäre es Kopf auf Kopf: nach Steuerbord ausweichen."
    },
    "explanation": {
      "en": "Three degrees off a reciprocal course and you already see only one sidelight. That is where the doubt comes from, head-on or crossing, and the rule settles it for you: assume the less convenient case.",
      "de": "Drei Grad neben dem Gegenkurs, und schon siehst du nur noch ein Seitenlicht. Genau daran entsteht der Zweifel, ob es Kopf auf Kopf ist oder Kreuzen, und die Regel löst ihn für dich: den ungünstigeren Fall annehmen."
    },
    "tags": [
      "power",
      "head-on"
    ],
    "expectSeen": [
      "masthead",
      "sidelight-stbd"
    ]
  },
  {
    "id": "s15-other-from-starboard",
    "rule": 15,
    "cite": [
      "a",
      "16:intro"
    ],
    "scope": "both",
    "title": {
      "en": "Crossing, the other vessel comes from starboard",
      "de": "Kreuzen, der andere kommt von Steuerbord"
    },
    "own": {
      "headingDeg": 0,
      "state": "r23-power-ge50"
    },
    "other": {
      "headingDeg": 270,
      "bearingDeg": 45,
      "distanceNm": 1.5,
      "state": "r23-power-ge50"
    },
    "giveWay": "own",
    "action": {
      "en": "Take early and substantial action to keep well clear, preferably passing astern.",
      "de": "Früh und deutlich ausweichen, am besten hinter dem anderen durch."
    },
    "explanation": {
      "en": "You see his red sidelight, so he shows you his port side and has you on his port side. He is on your right, and the vessel which has the other on her starboard side keeps out of the way.",
      "de": "Du siehst sein rotes Seitenlicht, also zeigt er dir seine Backbordseite und hat dich an seiner Backbordseite. Er ist rechts von dir, und wer den anderen an Steuerbord hat, weicht aus."
    },
    "tags": [
      "power",
      "crossing",
      "give-way"
    ],
    "expectSeen": [
      "masthead",
      "sidelight-port"
    ]
  },
  {
    "id": "s15-other-from-port",
    "rule": 15,
    "cite": [
      "a",
      "17:a(i)"
    ],
    "scope": "both",
    "title": {
      "en": "Crossing, the other vessel comes from port",
      "de": "Kreuzen, der andere kommt von Backbord"
    },
    "own": {
      "headingDeg": 0,
      "state": "r23-power-ge50"
    },
    "other": {
      "headingDeg": 90,
      "bearingDeg": 315,
      "distanceNm": 1.5,
      "state": "r23-power-ge50"
    },
    "giveWay": "other",
    "action": {
      "en": "Keep your course and speed, but watch whether the other vessel really gives way.",
      "de": "Kurs und Fahrt halten, aber beobachten, ob der andere wirklich ausweicht."
    },
    "explanation": {
      "en": "His green sidelight means you are on his starboard side, so he keeps out of the way. Holding your course is a duty here, not convenience, because he plans his manoeuvre around it.",
      "de": "Sein grünes Seitenlicht heißt: du bist an seiner Steuerbordseite, also weicht er aus. Kurs halten ist hier eine Pflicht, keine Bequemlichkeit, denn er richtet sein Manöver nach deinem Kurs."
    },
    "tags": [
      "power",
      "crossing",
      "stand-on"
    ],
    "expectSeen": [
      "masthead",
      "sidelight-stbd"
    ]
  },
  {
    "id": "s13-overtaking-power",
    "rule": 13,
    "cite": [
      "a",
      "b"
    ],
    "scope": "both",
    "title": {
      "en": "You are overtaking a power-driven vessel",
      "de": "Du überholst ein Maschinenfahrzeug"
    },
    "own": {
      "headingDeg": 0,
      "state": "r23-power-ge50"
    },
    "other": {
      "headingDeg": 0,
      "bearingDeg": 0,
      "distanceNm": 0.5,
      "state": "r23-power-ge50"
    },
    "giveWay": "own",
    "action": {
      "en": "Keep out of the way and stay clear until you are finally past and clear.",
      "de": "Ausweichen und klar vorbeigehen, bis du endgültig frei bist."
    },
    "explanation": {
      "en": "You see only his sternlight and nothing else. That is exactly the limit in Rule 13(b): more than 22.5 degrees abaft the beam means overtaking, and the overtaking vessel always keeps out of the way.",
      "de": "Du siehst nur sein Hecklicht, sonst nichts. Genau das ist die Grenze aus Regel 13(b): mehr als 22,5 Grad achterlicher als querab heißt überholen, und der Überholende weicht immer aus."
    },
    "tags": [
      "overtaking",
      "give-way"
    ],
    "expectSeen": [
      "sternlight"
    ]
  },
  {
    "id": "s13-being-overtaken",
    "rule": 13,
    "cite": [
      "a",
      "17:a(i)"
    ],
    "scope": "both",
    "title": {
      "en": "You are being overtaken",
      "de": "Du wirst überholt"
    },
    "own": {
      "headingDeg": 0,
      "state": "r23-power-ge50"
    },
    "other": {
      "headingDeg": 0,
      "bearingDeg": 180,
      "distanceNm": 0.5,
      "state": "r23-power-ge50"
    },
    "giveWay": "other",
    "action": {
      "en": "Keep your course and speed.",
      "de": "Kurs und Fahrt halten."
    },
    "explanation": {
      "en": "The other vessel comes up from astern. You see both his masthead lights and both sidelights, he sees only your sternlight. He gives way, you hold.",
      "de": "Der andere läuft von achtern auf. Du siehst seine beiden Topplichter und beide Seitenlichter, er sieht nur dein Hecklicht. Er weicht aus, du hältst."
    },
    "tags": [
      "overtaking",
      "stand-on"
    ],
    "expectSeen": [
      "masthead",
      "sidelight-port",
      "sidelight-stbd"
    ]
  },
  {
    "id": "s13-sailing-overtakes-power",
    "rule": 13,
    "cite": [
      "a",
      "18:intro"
    ],
    "scope": "both",
    "title": {
      "en": "A sailing vessel overtakes a power-driven vessel",
      "de": "Ein Segelfahrzeug überholt ein Maschinenfahrzeug"
    },
    "own": {
      "headingDeg": 0,
      "state": "r25-sailing-underway"
    },
    "other": {
      "headingDeg": 0,
      "bearingDeg": 0,
      "distanceNm": 0.4,
      "state": "r23-power-ge50"
    },
    "giveWay": "own",
    "action": {
      "en": "Keep out of the way even under sail: overtaking overrides the privilege of a sailing vessel.",
      "de": "Auch unter Segel ausweichen: Überholen schlägt den Vorrang des Seglers."
    },
    "explanation": {
      "en": "Rule 18 gives the sailing vessel privilege, but only where Rules 9, 10 and 13 do not require otherwise. When overtaking, they do.",
      "de": "Regel 18 räumt dem Segelfahrzeug Vorrang ein, aber nur dort, wo die Regeln 9, 10 und 13 nichts anderes sagen. Beim Überholen sagen sie etwas anderes."
    },
    "tags": [
      "overtaking",
      "sailing",
      "give-way"
    ],
    "expectSeen": [
      "sternlight"
    ]
  },
  {
    "id": "s12-different-tacks",
    "rule": 12,
    "cite": [
      "a",
      "a(i)"
    ],
    "scope": "both",
    "title": {
      "en": "Two sailing vessels, wind on different sides (wind from west)",
      "de": "Zwei Segelfahrzeuge, Wind von verschiedenen Seiten (Wind aus West)"
    },
    "own": {
      "headingDeg": 0,
      "state": "r25-sailing-underway"
    },
    "other": {
      "headingDeg": 135,
      "bearingDeg": 330,
      "distanceNm": 0.8,
      "state": "r25-sailing-underway"
    },
    "giveWay": "own",
    "action": {
      "en": "You have the wind on the port side and keep out of the way.",
      "de": "Du hast den Wind von Backbord und weichst aus."
    },
    "explanation": {
      "en": "You steer north with the wind on your port side, the other steers southeast with the wind on her starboard side. Wind on different sides: the vessel with the wind on the port side keeps out of the way. The lights do not tell you this, the wind does.",
      "de": "Du fährst Nord und hast den Wind von Backbord, der andere fährt Südost und hat ihn von Steuerbord. Wind von verschiedenen Seiten: der mit dem Wind von Backbord weicht aus. Das Lichterbild sagt dir das nicht, der Wind sagt es dir."
    },
    "tags": [
      "sailing",
      "give-way"
    ],
    "expectSeen": [
      "sidelight-stbd"
    ],
    "windFromDeg": 270
  },
  {
    "id": "s12-same-tack-windward",
    "rule": 12,
    "cite": [
      "a",
      "a(ii)"
    ],
    "scope": "both",
    "title": {
      "en": "Two sailing vessels, wind on the same side (wind from east)",
      "de": "Zwei Segelfahrzeuge, Wind von derselben Seite (Wind aus Ost)"
    },
    "own": {
      "headingDeg": 0,
      "state": "r25-sailing-underway"
    },
    "other": {
      "headingDeg": 160,
      "bearingDeg": 60,
      "distanceNm": 0.6,
      "state": "r25-sailing-underway"
    },
    "giveWay": "other",
    "action": {
      "en": "Keep your course and speed; the windward vessel keeps clear.",
      "de": "Kurs und Fahrt halten: der Luvfahrer weicht aus."
    },
    "explanation": {
      "en": "Both have the wind on the starboard side. The other lies on your starboard bow, closer to the wind: you are to leeward, she is to windward. Windward keeps clear of leeward, so she gives way and you hold your course.",
      "de": "Beide haben den Wind von Steuerbord. Der andere liegt an Steuerbord voraus, also näher am Wind: du bist in Lee, er in Luv. Luv weicht Lee, hier weicht also er, und du hältst Kurs."
    },
    "tags": [
      "sailing",
      "give-way"
    ],
    "expectSeen": [
      "sidelight-stbd"
    ],
    "windFromDeg": 90
  },
  {
    "id": "s12-uncertain",
    "rule": 12,
    "cite": [
      "a",
      "a(iii)"
    ],
    "scope": "both",
    "title": {
      "en": "Sailing vessel to windward, tack uncertain (wind from west)",
      "de": "Segler in Luv, Bug unklar (Wind aus West)"
    },
    "own": {
      "headingDeg": 0,
      "state": "r25-sailing-underway"
    },
    "other": {
      "headingDeg": 150,
      "bearingDeg": 20,
      "distanceNm": 0.7,
      "state": "r25-sailing-underway"
    },
    "giveWay": "own",
    "action": {
      "en": "When in doubt, keep out of the way.",
      "de": "Im Zweifel ausweichen."
    },
    "explanation": {
      "en": "You have the wind on the port side and see a vessel to windward whose tack you cannot determine. The rule does not ask for certainty, it asks for distance: when in doubt, keep out of the way.",
      "de": "Du hast den Wind von Backbord und siehst in Luv ein Fahrzeug, dessen Bug du nicht bestimmen kannst. Die Regel verlangt keine Gewissheit, sie verlangt Abstand: im Zweifel ausweichen."
    },
    "tags": [
      "sailing",
      "give-way"
    ],
    "expectSeen": [
      "sidelight-stbd"
    ],
    "windFromDeg": 270
  },
  {
    "id": "s17-standon-may-act",
    "rule": 17,
    "cite": [
      "a(ii)"
    ],
    "scope": "both",
    "title": {
      "en": "The give-way vessel is not acting",
      "de": "Der Ausweichpflichtige handelt nicht"
    },
    "own": {
      "headingDeg": 0,
      "state": "r23-power-ge50"
    },
    "other": {
      "headingDeg": 90,
      "bearingDeg": 315,
      "distanceNm": 0.8,
      "state": "r23-power-ge50"
    },
    "giveWay": "other",
    "action": {
      "en": "You may manoeuvre alone as soon as it is apparent that the give-way vessel is not acting.",
      "de": "Du darfst selbst manövrieren, sobald erkennbar ist, dass der andere nichts tut."
    },
    "explanation": {
      "en": "Holding course is a duty, but not a duty until collision. As soon as it becomes apparent the other is doing nothing, you may act, and preferably not to port.",
      "de": "Kurshalten ist Pflicht, aber keine Pflicht bis zum Zusammenstoß. Sobald klar wird, dass der andere nichts unternimmt, darfst du handeln, und zwar am besten nicht nach Backbord."
    },
    "tags": [
      "power",
      "crossing",
      "stand-on"
    ],
    "expectSeen": [
      "masthead",
      "sidelight-stbd"
    ]
  },
  {
    "id": "s17-standon-must-act",
    "rule": 17,
    "cite": [
      "b"
    ],
    "scope": "both",
    "title": {
      "en": "Collision cannot be avoided by the give-way vessel alone",
      "de": "Zusammenstoß nur noch gemeinsam vermeidbar"
    },
    "own": {
      "headingDeg": 0,
      "state": "r23-power-ge50"
    },
    "other": {
      "headingDeg": 90,
      "bearingDeg": 315,
      "distanceNm": 0.2,
      "state": "r23-power-ge50"
    },
    "giveWay": "both",
    "action": {
      "en": "Now you must act, and in the way that best helps to avoid collision.",
      "de": "Jetzt musst du handeln, und zwar so, dass der Zusammenstoß am besten vermieden wird."
    },
    "explanation": {
      "en": "The permission becomes a duty when the situation is so close that the other vessel alone can no longer prevent collision. The rules know no stand-on vessel that sails into a ship.",
      "de": "Aus dem Dürfen wird ein Müssen, wenn die Lage so eng ist, dass der andere allein nichts mehr ausrichtet. Die Regel kennt keinen Kurshalter, der in ein Schiff hineinfährt."
    },
    "tags": [
      "power",
      "crossing",
      "stand-on"
    ],
    "expectSeen": [
      "masthead",
      "sidelight-stbd"
    ]
  },
  {
    "id": "s18-power-vs-nuc",
    "rule": 18,
    "cite": [
      "18:a",
      "18:a(i)"
    ],
    "scope": "both",
    "title": {
      "en": "Power-driven vessel meets a vessel not under command",
      "de": "Maschinenfahrzeug trifft manövrierunfähiges Fahrzeug"
    },
    "own": {
      "headingDeg": 0,
      "state": "r23-power-ge50"
    },
    "other": {
      "headingDeg": 270,
      "bearingDeg": 45,
      "distanceNm": 1.2,
      "state": "r27-nuc-making-way"
    },
    "giveWay": "own",
    "action": {
      "en": "Keep out of the way and pass well clear.",
      "de": "Ausweichen und klar vorbeigehen."
    },
    "explanation": {
      "en": "Two red all-round lights in a vertical line and no masthead light: the other vessel cannot manoeuvre. Rule 18 puts her at the top of the order, and you keep out of the way whatever the bearing.",
      "de": "Zwei rote Rundumlichter senkrecht und kein Topplicht: der andere kann nicht manövrieren. Regel 18 stellt ihn ganz oben in die Rangfolge, und du weichst aus, aus welcher Richtung er auch kommt."
    },
    "tags": [
      "responsibilities",
      "give-way",
      "not-under-command"
    ],
    "expectSeen": [
      "allround",
      "sidelight-port"
    ]
  },
  {
    "id": "s18-power-vs-ram",
    "rule": 18,
    "cite": [
      "18:a",
      "18:a(ii)"
    ],
    "scope": "both",
    "title": {
      "en": "Power-driven vessel meets a vessel restricted in her ability to manoeuvre",
      "de": "Maschinenfahrzeug trifft manövrierbehindertes Fahrzeug"
    },
    "own": {
      "headingDeg": 0,
      "state": "r23-power-ge50"
    },
    "other": {
      "headingDeg": 270,
      "bearingDeg": 45,
      "distanceNm": 1.2,
      "state": "r27-ram"
    },
    "giveWay": "own",
    "action": {
      "en": "Keep out of the way and pass well clear.",
      "de": "Ausweichen und klar vorbeigehen."
    },
    "explanation": {
      "en": "Red over white over red: his work prevents him from keeping out of the way. You move, and early, because often he cannot alter course at all.",
      "de": "Rot über weiß über rot: die Arbeit des anderen hindert ihn am Ausweichen. Du gehst aus dem Weg, und zwar früh, weil er seinen Kurs oft gar nicht ändern kann."
    },
    "tags": [
      "responsibilities",
      "give-way"
    ],
    "expectSeen": [
      "allround",
      "masthead",
      "sidelight-port"
    ]
  },
  {
    "id": "s18-power-vs-fishing",
    "rule": 18,
    "cite": [
      "18:a",
      "18:a(iii)"
    ],
    "scope": "both",
    "title": {
      "en": "Power-driven vessel meets a vessel engaged in fishing",
      "de": "Maschinenfahrzeug trifft Fischereifahrzeug"
    },
    "own": {
      "headingDeg": 0,
      "state": "r23-power-ge50"
    },
    "other": {
      "headingDeg": 270,
      "bearingDeg": 45,
      "distanceNm": 1.2,
      "state": "r26-trawler-lt50"
    },
    "giveWay": "own",
    "action": {
      "en": "Keep out of the way and pass well clear.",
      "de": "Ausweichen und klar vorbeigehen."
    },
    "explanation": {
      "en": "Green over white: the other vessel is trawling. Her gear is in the water and she cannot leave it, so you keep clear.",
      "de": "Grün über weiß und kein Topplicht: ein Trawler unter 50 m beim Fischen. Er hat Netze im Wasser und kann ihnen nicht ausweichen, deshalb weichst du aus."
    },
    "tags": [
      "responsibilities",
      "give-way"
    ],
    "expectSeen": [
      "allround",
      "sidelight-port"
    ]
  },
  {
    "id": "s18-power-vs-sailing",
    "rule": 18,
    "cite": [
      "18:a",
      "18:a(iv)"
    ],
    "scope": "both",
    "title": {
      "en": "Power-driven vessel meets a sailing vessel",
      "de": "Maschinenfahrzeug trifft Segelfahrzeug"
    },
    "own": {
      "headingDeg": 0,
      "state": "r23-power-ge50"
    },
    "other": {
      "headingDeg": 270,
      "bearingDeg": 45,
      "distanceNm": 1.2,
      "state": "r25-sailing-underway"
    },
    "giveWay": "own",
    "action": {
      "en": "Keep out of the way and pass well clear.",
      "de": "Ausweichen und klar vorbeigehen."
    },
    "explanation": {
      "en": "No masthead light above the sidelights: a sailing vessel. As long as she is really under sail alone, the power-driven vessel keeps out of the way.",
      "de": "Kein Topplicht über den Seitenlichtern: ein Segelfahrzeug. Solange es wirklich nur segelt, weicht das Maschinenfahrzeug aus."
    },
    "tags": [
      "responsibilities",
      "give-way"
    ],
    "expectSeen": [
      "sidelight-port"
    ]
  },
  {
    "id": "s18-sailing-vs-nuc",
    "rule": 18,
    "cite": [
      "18:b",
      "18:b(i)"
    ],
    "scope": "both",
    "title": {
      "en": "Sailing vessel meets a vessel not under command",
      "de": "Segelfahrzeug trifft manövrierunfähiges Fahrzeug"
    },
    "own": {
      "headingDeg": 0,
      "state": "r25-sailing-underway"
    },
    "other": {
      "headingDeg": 270,
      "bearingDeg": 45,
      "distanceNm": 1.2,
      "state": "r27-nuc-making-way"
    },
    "giveWay": "own",
    "action": {
      "en": "Keep out of the way even under sail.",
      "de": "Auch unter Segel ausweichen."
    },
    "explanation": {
      "en": "The privilege of a sailing vessel ends with those who simply cannot: not under command and restricted in ability to manoeuvre rank above her.",
      "de": "Der Vorrang des Seglers endet bei denen, die überhaupt nicht können. Zwei rote Rundumlichter ohne Topplicht heißen manövrierunfähig, und die steht über dem Segelfahrzeug."
    },
    "tags": [
      "sailing",
      "responsibilities",
      "give-way"
    ],
    "expectSeen": [
      "allround",
      "sidelight-port"
    ]
  },
  {
    "id": "s18-sailing-vs-fishing",
    "rule": 18,
    "cite": [
      "18:b",
      "18:b(iii)"
    ],
    "scope": "both",
    "title": {
      "en": "Sailing vessel meets a vessel engaged in fishing",
      "de": "Segelfahrzeug trifft Fischereifahrzeug"
    },
    "own": {
      "headingDeg": 0,
      "state": "r25-sailing-underway"
    },
    "other": {
      "headingDeg": 270,
      "bearingDeg": 45,
      "distanceNm": 1.2,
      "state": "r26-trawler-lt50"
    },
    "giveWay": "own",
    "action": {
      "en": "Keep out of the way, even under sail.",
      "de": "Ausweichen, auch wenn du unter Segel bist."
    },
    "explanation": {
      "en": "In the order of responsibilities fishing ranks above sail. A vessel fishing is tied to her gear, a sailing vessel can tack.",
      "de": "In der Rangfolge steht Fischerei über Segel. Wer fischt, hängt an seinem Geschirr, wer segelt, kann kreuzen."
    },
    "tags": [
      "sailing",
      "responsibilities",
      "give-way"
    ],
    "expectSeen": [
      "allround",
      "sidelight-port"
    ]
  },
  {
    "id": "s18-fishing-vs-ram",
    "rule": 18,
    "cite": [
      "18:c",
      "18:c(ii)"
    ],
    "scope": "both",
    "title": {
      "en": "Fishing vessel meets a vessel restricted in her ability to manoeuvre",
      "de": "Fischereifahrzeug trifft manövrierbehindertes Fahrzeug"
    },
    "own": {
      "headingDeg": 0,
      "state": "r26-trawler-lt50"
    },
    "other": {
      "headingDeg": 270,
      "bearingDeg": 45,
      "distanceNm": 1.2,
      "state": "r27-ram"
    },
    "giveWay": "own",
    "action": {
      "en": "Keep out of the way so far as possible.",
      "de": "So weit möglich ausweichen."
    },
    "explanation": {
      "en": "The wording here is softer: so far as possible. A vessel towing a net cannot turn at will, and the rule knows it.",
      "de": "Der Wortlaut ist hier weicher: so weit möglich. Wer ein Netz schleppt, kann nicht jederzeit drehen, und die Regel weiß das."
    },
    "tags": [
      "fishing",
      "responsibilities",
      "give-way"
    ],
    "expectSeen": [
      "allround",
      "masthead",
      "sidelight-port"
    ]
  },
  {
    "id": "s18-constrained-draught",
    "rule": 18,
    "cite": [
      "18:d(i)"
    ],
    "scope": "international",
    "title": {
      "en": "Vessel constrained by her draught in the channel",
      "de": "Tiefgangbehindertes Fahrzeug im Fahrwasser"
    },
    "own": {
      "headingDeg": 0,
      "state": "r23-power-ge50"
    },
    "other": {
      "headingDeg": 180,
      "bearingDeg": 10,
      "distanceNm": 2,
      "state": "r28-constrained-draught"
    },
    "giveWay": "own",
    "action": {
      "en": "Do not impede her safe passage: make room early and clearly.",
      "de": "Die sichere Durchfahrt nicht behindern: früh und deutlich Platz machen."
    },
    "explanation": {
      "en": "Three red all-round lights in a vertical line. She is neither give-way nor stand-on in the usual sense: you simply must not impede her, which means not getting in her way in the first place.",
      "de": "Drei rote Rundumlichter senkrecht über den Lichtern eines Maschinenfahrzeugs. Sie ist nicht ausweichpflichtig und nicht bevorrechtigt im üblichen Sinn: du darfst sie nur nicht behindern, und das heißt, gar nicht erst in ihre Nähe zu kommen."
    },
    "tags": [
      "responsibilities",
      "constrained-draught"
    ],
    "expectSeen": [
      "allround",
      "masthead",
      "sidelight-stbd"
    ]
  },
  {
    "id": "s18-seaplane",
    "rule": 18,
    "cite": [
      "18:e"
    ],
    "scope": "both",
    "title": {
      "en": "Seaplane on the water",
      "de": "Wasserflugzeug auf dem Wasser"
    },
    "own": {
      "headingDeg": 0,
      "state": "r23-power-ge50"
    },
    "other": {
      "headingDeg": 270,
      "bearingDeg": 45,
      "distanceNm": 1,
      "state": "r31-seaplane"
    },
    "giveWay": "other",
    "action": {
      "en": "Keep your course: the seaplane keeps well clear of all vessels.",
      "de": "Kurs halten: das Wasserflugzeug hält sich von allen frei."
    },
    "explanation": {
      "en": "A seaplane shall in general keep well clear of all vessels. Where risk of collision exists nevertheless, the ordinary rules apply to her as to any vessel.",
      "de": "Ein Wasserflugzeug hält sich grundsätzlich von allen Fahrzeugen frei. Besteht trotzdem die Gefahr eines Zusammenstoßes, gelten für es die Regeln wie für jedes andere Fahrzeug."
    },
    "tags": [
      "responsibilities",
      "stand-on"
    ],
    "expectSeen": [
      "masthead",
      "sidelight-port"
    ]
  },
  {
    "id": "s9-narrow-channel",
    "rule": 9,
    "cite": [
      "a"
    ],
    "scope": "both",
    "title": {
      "en": "Narrow channel",
      "de": "Enges Fahrwasser"
    },
    "own": {
      "headingDeg": 0,
      "state": "r23-power-ge50"
    },
    "other": {
      "headingDeg": 180,
      "bearingDeg": 10,
      "distanceNm": 1,
      "state": "r23-power-ge50"
    },
    "giveWay": "both",
    "action": {
      "en": "Keep as near to the starboard side of the channel as is safe and practicable.",
      "de": "So nah wie sicher möglich an der eigenen Steuerbordseite des Fahrwassers bleiben."
    },
    "explanation": {
      "en": "In a narrow channel no crossing rule is needed: everyone keeps right. Because both keep right you see only his green sidelight, and that is what a properly used channel looks like.",
      "de": "Im engen Fahrwasser braucht es keine Kreuzungsregel: jeder hält rechts. Weil beide rechts halten, siehst du vom Gegenkommer nur sein grünes Seitenlicht, und genau das ist das Bild eines sauber gefahrenen Fahrwassers."
    },
    "tags": [
      "narrow-channel"
    ],
    "expectSeen": [
      "masthead",
      "sidelight-stbd"
    ]
  },
  {
    "id": "s9-not-impede",
    "rule": 9,
    "cite": [
      "b"
    ],
    "scope": "both",
    "title": {
      "en": "Small vessel in a narrow channel",
      "de": "Kleines Fahrzeug im engen Fahrwasser"
    },
    "own": {
      "headingDeg": 0,
      "state": "r23-power-lt12"
    },
    "other": {
      "headingDeg": 180,
      "bearingDeg": 5,
      "distanceNm": 1,
      "state": "r23-power-ge50"
    },
    "giveWay": "own",
    "action": {
      "en": "Do not impede her passage: leave the channel in good time.",
      "de": "Die Durchfahrt nicht behindern: rechtzeitig aus dem Fahrwasser heraus."
    },
    "explanation": {
      "en": "A vessel of less than 20 metres or a sailing vessel shall not impede a vessel which can navigate safely only within the channel. Not impeding is more than giving way: it means not letting the situation arise.",
      "de": "Ein Fahrzeug unter 20 m oder ein Segelfahrzeug darf ein Fahrzeug nicht behindern, das nur innerhalb des Fahrwassers sicher fahren kann. Nicht behindern ist mehr als ausweichen: es heißt, erst gar keine Lage entstehen zu lassen."
    },
    "tags": [
      "narrow-channel",
      "give-way"
    ],
    "expectSeen": [
      "masthead",
      "sidelight-stbd"
    ]
  },
  {
    "id": "s10-tss-crossing",
    "rule": 10,
    "cite": [
      "c"
    ],
    "scope": "both",
    "title": {
      "en": "Crossing a traffic separation scheme",
      "de": "Verkehrstrennungsgebiet queren"
    },
    "own": {
      "headingDeg": 90,
      "state": "r23-power-ge50"
    },
    "other": {
      "headingDeg": 0,
      "bearingDeg": 90,
      "distanceNm": 2,
      "state": "r23-power-ge50"
    },
    "giveWay": "own",
    "action": {
      "en": "Cross on a heading as nearly as practicable at right angles to the general direction of traffic flow.",
      "de": "Auf einem Kurs queren, der möglichst rechtwinklig zur Verkehrsrichtung liegt."
    },
    "explanation": {
      "en": "You cross to the east, the traffic runs north. The vessel coming up shows you both sidelights because you are right ahead of her. Crossing at right angles means being in the way as briefly as possible and staying predictable.",
      "de": "Du querst nach Osten, der Verkehr läuft nach Norden. Der Aufkommer zeigt dir beide Seitenlichter, weil du genau vor seinem Bug stehst. Rechtwinklig queren heißt: so kurz wie möglich im Weg sein und berechenbar bleiben."
    },
    "tags": [
      "tss"
    ],
    "expectSeen": [
      "masthead",
      "sidelight-port",
      "sidelight-stbd"
    ]
  },
  {
    "id": "s19-restricted",
    "rule": 19,
    "cite": [
      "d"
    ],
    "scope": "both",
    "title": {
      "en": "Restricted visibility, a contact ahead",
      "de": "Eingeschränkte Sicht, Echo voraus"
    },
    "own": {
      "headingDeg": 0,
      "state": "r23-power-ge50"
    },
    "other": {
      "headingDeg": 20,
      "bearingDeg": 20,
      "distanceNm": 3,
      "state": "r23-power-ge50"
    },
    "giveWay": "both",
    "action": {
      "en": "Reduce speed and avoid an alteration of course to port for a vessel forward of the beam.",
      "de": "Fahrt herabsetzen, Kursänderung nach Backbord für ein Echo vorlicher als querab vermeiden."
    },
    "explanation": {
      "en": "In restricted visibility there is no stand-on vessel. Whoever has the contact acts, and two manoeuvres are ruled out: to port for a vessel forward of the beam, and towards a vessel abeam or abaft the beam.",
      "de": "Bei eingeschränkter Sicht gibt es keinen Kurshalter. Wer ein Echo hat, handelt selbst, und zwei Manöver sind ausdrücklich verboten: nach Backbord für etwas vorlicher als querab, und hin zu etwas querab oder achterlicher."
    },
    "tags": [
      "restricted-visibility"
    ]
  }
]
